import { ReactElement } from 'react'
import Layout from '../../components/layout'
import EditShop from '../../components/Shops/AddShop'

const ShopEditPage = (): ReactElement => {
  return (
    <Layout >
      <EditShop />
    </Layout>
  )
}

export default ShopEditPage
